var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ opacity: _vm.clientOpacity }),attrs:{"id":"destaque-pdf"}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"py-2",attrs:{"cols":"12"}})],1)],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":"","id":"barraSecundaria-pdf"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9700b6d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/pdf/destaque.vue
// module id = rHIx
// module chunks = 1